export enum ChemotherapyArticleCodes {
  RELATED_TOPICS = 'level2_related_topics_detail',
  ORAL = 'level2_article_detail_oral',
  DOCTOR = 'level2_article_detail_doctor',
}
